import {
  vs2ngaGlobalReleaseConstants,
  addVs2ngaGlobalReleaseConstants,
  editVs2ngaGlobalReleaseConstants,
} from "../_redux-constants";
import { vs2ngaGlobalReleaseService } from "../../_services";

function getVs2ngaGlobalRelease() {
  function getVs2ngaGlobalReleaseLoad() {
    return { type: vs2ngaGlobalReleaseConstants.VS2NGA_GLOBAL_RELEASE_LOADING };
  }
  function getVs2ngaGlobalReleaseSuccess(data) {
    return {
      type: vs2ngaGlobalReleaseConstants.VS2NGA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function getVs2ngaGlobalReleaseFailure(error) {
    return {
      type: vs2ngaGlobalReleaseConstants.VS2NGA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getVs2ngaGlobalReleaseLoad());
    return vs2ngaGlobalReleaseService.getVs2ngaGlobalRelease().then(
      (data) => {
        dispatch(getVs2ngaGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(getVs2ngaGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function addVs2ngaGlobalRelease(formData) {
  function addVs2ngaGlobalReleaseLoad() {
    return {
      type: addVs2ngaGlobalReleaseConstants.ADD_VS2NGA_GLOBAL_RELEASE_LOADING,
    };
  }
  function addVs2ngaGlobalReleaseSuccess(data) {
    return {
      type: addVs2ngaGlobalReleaseConstants.ADD_VS2NGA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function addVs2ngaGlobalReleaseFailure(error) {
    return {
      type: addVs2ngaGlobalReleaseConstants.ADD_VS2NGA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addVs2ngaGlobalReleaseLoad());
    return vs2ngaGlobalReleaseService.addVs2ngaGlobalRelease(formData).then(
      (data) => {
        dispatch(addVs2ngaGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(addVs2ngaGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function editVs2ngaGlobalRelease(formData) {
  function editVs2ngaGlobalReleaseLoad() {
    return {
      type: editVs2ngaGlobalReleaseConstants.EDIT_VS2NGA_GLOBAL_RELEASE_LOADING,
    };
  }
  function editVs2ngaGlobalReleaseSuccess(data) {
    return {
      type: editVs2ngaGlobalReleaseConstants.EDIT_VS2NGA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function editVs2ngaGlobalReleaseFailure(error) {
    return {
      type: editVs2ngaGlobalReleaseConstants.EDIT_VS2NGA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editVs2ngaGlobalReleaseLoad());
    return vs2ngaGlobalReleaseService.editVs2ngaGlobalRelease(formData).then(
      (data) => {
        dispatch(editVs2ngaGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(editVs2ngaGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

export const vs2ngaGlobalReleaseActions = {
  getVs2ngaGlobalRelease,
  addVs2ngaGlobalRelease,
  editVs2ngaGlobalRelease,
};
